export default "<checkout-profile-user [isNew]=\"isNew\" [profileType]=\"profileUsers.Processor\"></checkout-profile-user>"